import { getSrcSetImageWidths } from './constants';
export function getImageSrcSet(maxWidth, getImageUrl) {
    return getSrcSetImageWidths(maxWidth)
        .map(width => {
        const url = getImageUrl(width);
        return `${url} ${width}w`;
    })
        .join(',');
}
